import request from "./../utils/request.js";

//获得班级课程评论列表
export function leaveamessagesel(data){
  return request.get('content/leaveamessagesel',data)
}
//获得课次评价详情
export function leaveamessageinquireall(data){
  return request.get('content/leaveamessageinquireall',data)
}
//获得学员课次评价详情
export function leaveamessageinquire(data){
  return request.get('content/leaveamessageinquire',data)
}
//评论学员课次
export function commentLessonTime(data){
  return request.get('content/leaveamessageamend',data)
}
//获得学员课次评价详情2
export function lessonSListSelect(data){
  return request.get('content/leaveamessagepage',data)
}
//获取评论信息详情
export function commentInfoDesc(data){
  return request.get('content/leaveameshavecomments',data)
}
//获取作业点评详情
export function commentWorksInfo(data){
  return request.get('content/studentdetailsinformationlist',data)
}
//查看作业点评详情
export function commentWorksInfoVisit(data){
  return request.get('content/studentdetailsinformation',data)
}
//查看未读评论数
export function notVisitCommentCount(data){
  return request.get('content/studentdetailsinformationliststat',data)
}